<template>
<div class="site-detail">
    <Error @reload="getData()" v-if="networkError" />
    <div class="intro-page" v-else-if="showPage">
        <v-banner :site="product" />
        <div class="intro-wrapper">
            <div class="intro-brief">
                <div class="intro-name">{{ product.name }}</div>
            </div>
            <v-detail-content :detailArray="guideArray"
                              :site="product"
                              siteType="event" />
        </div>
        <div class="explore-around">
            <v-explore-list :sites="product.sites" :hotels="product.hotels" :merchants="product.merchants" />
        </div>
    </div>
</div>
</template>

<script>
import { getEventDetail } from '@/fetch/api'
import Error from '@/components/Error.vue'
import DetailContent from '@/components/scenic/DetailContent.vue'
import Banner from '@/components/scenic/Banner.vue'
import ExploreList from '@/components/scenic/ExploreList.vue'

export default {
    data () {
        return {
            siteId: '1',
            showPage: false,
            id: '',
            product: {},
            guideArray: [],
            networkError: false
        }
    },
    components: {
        Error,
        'v-detail-content': DetailContent,
        'v-banner': Banner,
        'v-explore-list': ExploreList
    },
    created () {
        document.title = this.$t('poi.eventTitle')
        this.toast = this.$createToast({
            time: 0,
            txt: this.$t('common.loadingMsg'),
            mask: true
        })
        this.toast.show()
        navigator.geolocation.getCurrentPosition((res) => {
            const longitude = res.coords.longitude
            const latitude = res.coords.latitude
            this.geoData = {
                lon: longitude,
                lat: latitude
            }
            // console.log(longitude, latitude)
            if (longitude) {
                this.getData()
            }
        }, err => {
            this.geoData = {
                lon: 103.82241,
                lat: 1.2651
            }
            this.getData()
        }, { timeout: 5000, enableHighAccuracy: true })
    },
    methods: {
        getData () {
            const params = {
                lon: this.geoData.lon,
                lat: this.geoData.lat
            }
            if (this.$route.query.language === 'zh') {
                params.locale = 'cn'
            } else {
                params.locale = 'en'
            }
            getEventDetail(this.$route.params.id, params).then(res => {
                this.networkError = false
                this.product = res
                this.guideArray = this.processGuide(res)
                this.showPage = true
                this.toast.hide()
            }).catch(err => {
                console.log(err)
                this.toast.hide()
                this.networkError = true
            })
        },
        processGuide (site) {
            let guideArray = []
            if (site.description) {
                guideArray.push({
                    id: 'description',
                    text: this.$t('poi.eventDesc'),
                    content: site.description
                })
            }
            if (site.operation_time) {
                guideArray.push({
                    id: 'time',
                    text: this.$t('poi.eventTime'),
                    content: site.operation_time
                })
            }
            if (site.phone_number) {
                guideArray.push({
                    id: 'number',
                    text: this.$t('poi.number'),
                    content: site.phone_number
                })
            }
            if (site.website) {
                guideArray.push({
                    id: 'website',
                    text: this.$t('poi.website'),
                    content: site.website
                })
            }
            if (site.ticket_strategy) {
                guideArray.push({
                    id: 'ticket',
                    text: this.$t('poi.ticket'),
                    content: site.ticket_strategy
                })
            }
            if (site.traffic_strategy) {
                guideArray.push({
                    id: 'traffic',
                    text: this.$t('poi.traffic'),
                    content: site.traffic_strategy
                })
            }
            if (site.play_strategy) {
                guideArray.push({
                    id: 'recommend',
                    text: this.$t('poi.recommend'),
                    content: site.play_strategy
                })
            }
            if (site.address) {
                guideArray.push({
                    id: 'address',
                    text: this.$t('poi.address '),
                    content: site.address
                })
            }
            return guideArray
        },
    }
}
</script>
